import React, { useState, useEffect } from 'react';
import { Skeleton, Empty, Modal, notification } from 'antd';
import { Breadcrumbs } from '../../../components/Atom/breadcumbs';
import { Button, ResetButton } from '../../../components/Atom/Button';
import { PageHeader } from '../../../components/Atom/PageHeader';
import '../style.css';
import { useSelector } from 'react-redux';
import { useQuery, useQueryClient } from 'react-query';
import GatewayInstance from './gatewayInstance';
import { USER_ROLES, STORE_API_VERSION } from 'utils/constant';
import { checkUserPermissions } from 'utils/services';
import Table from 'components/Table';
import { deleteGatewayInstance, getGateways } from 'api/gateways';
import { searchBank } from 'utils/services';
import StatusTag from 'components/Atom/StatusTag';
export const Gateway = () => {
  const queryClient = useQueryClient();
  const [drawer, setDrawer] = useState({
    open: false,
    data: null,
    type: null,
  });
  const store = useSelector((state) => state.company.store);
  const { data, refetch, isLoading, isRefetching } = useQuery('gateways', () => getGateways(store?._id), {
    enabled: false,
    manual: true,
    initialData: store,
  });
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [isGatewayDeleting, setIsGatewayDeleting] = useState(false);

  useEffect(() => {
    refetch();
  }, [store]);
  const handleUpdateStoreData = (e) => {
    queryClient.setQueryData('gateways', e);
  };
  const handleEditDetails = (type = null, data = null) => {
    setDrawer({ open: !drawer.open, data: data, type });
  };
  const onDeleteInstance = async (value) => {
    setIsGatewayDeleting(true);
    try {
      const res = await deleteGatewayInstance(store?._id, value?._id);
      notification.success({ message: 'Gateway Deleted', description: 'Gateway has been deleted successfully.', placement: 'bottomRight' });
      handleUpdateStoreData(res ?? '');
    } catch (err) {
      notification.error({ message: err?.response?.data?.message || 'Failed to delete the gateway. Please try again.', placement: 'bottomRight' });
    }
    setOpenDeleteModal(false);
    setIsGatewayDeleting(false);
  };
  const [gatewayInstanceId, setGatewayInstanceId] = useState(null);
  const setDeleteModal = (value) => {
    setGatewayInstanceId(value);
    setOpenDeleteModal(true);
  };
  const columnsData = [
    {
      title: 'Gateway ID',
      render: (value) => value?._id,
      key: 'instanceId',
    },
    {
      title: 'Name',
      render: (value) => value?.name,
      key: 'instanceName',
    },
    {
      title: 'Default',
      render: (value) => <StatusTag tag={value?.isDefault ? 'YES' : 'NO'} />,
      key: 'default',
    },
    {
      title: 'Payment Method',
      render: (value) => value?.payment_method?.toUpperCase(),
      key: 'paymentMethod',
    },
    {
      title: 'Gateway Type',
      render: (value) => searchBank(value?.gateway_type),
      key: 'type',
    },
    {
      title: 'Status',
      render: (value) => <StatusTag tag={value?.disabled ? 'disabled' : 'enabled'} />,
      key: 'status',
    },
    ...(checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN, USER_ROLES.XPAY_DEVELOPER])
      ? [
          {
            title: 'Action',
            key: 'action',
            render: (value) => {
              return (
                <div style={{ display: 'flex', flexWrap: 'nowrap' }}>
                  <div className='table-action-btn w-[56px] flex items-center justify-center' style={{ fontSize: '14px', cursor: 'pointer' }} onClick={() => handleEditDetails('instance', value)}>
                    Edit
                  </div>
                  <div className='table-action-btn ml-3' style={{ color: '#E12121', border: '1px solid #E12121', fontSize: '14px', cursor: 'pointer' }} onClick={() => setDeleteModal(value)}>
                    Delete
                  </div>
                </div>
              );
            },
          },
        ]
      : []),
  ];
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Gateways',
      },
    ],
  };
  return (
    <div style={{ padding: '0px', width: '100%' }}>
      <div className='header-container p-4'>
        <div>
          <Breadcrumbs {...breadcrumbProps} />
        </div>
        <div className='headerPage'>
          <div className='child'>
            <PageHeader label={'Gateways'} button={<ResetButton onClick={isRefetching ? '' : refetch} loading={isRefetching} />} />
          </div>
          <div className='flexStoreFields m-r-10 selectStore'>
            {checkUserPermissions([USER_ROLES.XPAY_ADMIN, USER_ROLES.XPAY_RESTRICTED_ADMIN]) && (
              <>
                {store?.apiVersion === STORE_API_VERSION.OCTOBER_23 && (
                  <Button className=' w-[132px] button-theme rounded-lg' onClick={() => handleEditDetails('instance')}>
                    Add Gateway
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <br />
      {store?.apiVersion === STORE_API_VERSION.OCTOBER_23 && (
        <div className='overflow-x-auto custom-table'>
          <Table rowKey={(e) => e._id} loading={isLoading} dataSource={data?.length > 0 ? data : null} columns={columnsData} totalLenght={null} pagingation={{ show: false }} />
        </div>
      )}
      <Modal destroyOnClose onCancel={handleEditDetails} className='' open={drawer.open} width={400} footer={null}>
        <div className='GatewayModal'>
          <div className='font-semibold text-base mb-6'>Gateway Configuration</div>
          <GatewayInstance handleOpen={handleEditDetails} updateState={handleUpdateStoreData} store={store} instanceData={data} editData={drawer.data} />
        </div>
      </Modal>
      <Modal
        destroyOnCloseopenDeleteModal
        open={openDeleteModal}
        onCancel={() => {
          setOpenDeleteModal(false);
        }}
        width={400}
        okButtonProps={{ loading: isGatewayDeleting }}
        footer={null}>
        <>
          <header className='font-semibold text-base mb-4'>Delete Gateway</header>
          <div>Are you sure you want to delete this gateway?</div>
          <div className='flex mt-4'>
            <Button
              className='rounded-lg bg-plain'
              block
              onClick={() => {
                setOpenDeleteModal(false);
              }}>
              Cancel
            </Button>
            <Button block className='DeleteBtn rounded-lg ml-4' onClick={() => onDeleteInstance(gatewayInstanceId)} loading={isGatewayDeleting}>
              Confirm
            </Button>
          </div>
        </>
      </Modal>
    </div>
  );
};
